import { useIntl } from "react-intl";

import PresenceActiveIcon from "@atlaskit/icon/glyph/presence-active";

import Link from "@/components/wpl/link/src";
import { useLocalizedHref } from "@/libraries/web-framework";

import { tabbedHeroSectionDatabasesMessages } from "../messages/tabbed-hero-section.messages";

import { ContentTypeVideo } from "./content-type-video";

export const DatabasesContentType = () => {
    const intl = useIntl();
    const ctaLink = useLocalizedHref("/software/confluence/databases");

    return (
        <ContentTypeVideo
            title={intl.formatMessage(
                tabbedHeroSectionDatabasesMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionDatabasesMessages.contentDescription
            )}
            iconTitle={intl.formatMessage(
                tabbedHeroSectionDatabasesMessages.contentIconTitle
            )}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionDatabasesMessages.contentFeaturePoint1
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionDatabasesMessages.contentFeaturePoint2
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionDatabasesMessages.contentFeaturePoint3
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                }
            ]}
            cta={
                <Link
                    href={ctaLink}
                    text={intl.formatMessage(
                        tabbedHeroSectionDatabasesMessages.contentCta
                    )}
                    type={"basic"}
                    doesArrowAnimate={true}
                    dataEventProps={{
                        "data-product-key": "confluence",
                        "data-event-component": "linkButton",
                        "data-event-container": "contentTypesSection",
                        "data-event": "clicked",
                        "data-label": "explore-databases",
                        "data-label-english": "Explore Databases",
                        "data-track-event":
                            "confluence-pt.content-types.databases.cta"
                    }}
                />
            }
            reverseLayout
            videoSrc="https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm"
            videoPreviewSrc="https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp"
        />
    );
};
